import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriggerIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 12.5L12 8.5M12 8.5L8 12.5M12 8.5V17.7C12 19.0907 12 19.7861 12.5505 20.5646C12.9163 21.0819 13.9694 21.7203 14.5972 21.8054C15.5421 21.9334 15.9009 21.7462 16.6186 21.3719C19.8167 19.7036 22 16.3568 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 16.2014 4.01099 19.4331 7 21.1622",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTriggerIcon;
